<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div v-if="isLoading"><Loader /></div>
        <templates-table
            :templates="templates"
            :filter="filter"
            :refresh="fetchData"
            v-else
        />
      </div>
    </div>
  </div>
</template>

<script>
import TemplatesTable from "./components/TemplatesTable.vue";
import Loader from "./components/Loader.vue";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import {fetchTemplates} from "../api/services/templates";
const isLoading = ref(false);
const templates = ref([]);
export default {
  name: "templates",
  components: {
    TemplatesTable,
    Loader,
  },
  setup() {
    const fetchData = async (filter, page) => {
      isLoading.value = true;
      //console.log(filter);
      try {
        const response = await fetchTemplates(filter, page);
        templates.value = response.data;
        isLoading.value = false;
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
      }
    };
    onMounted(() => {
      const route = useRoute();
      const entity_params = ref();
      entity_params.value = {
        insurance_id: route.params?.insurance_id,
      };
      fetchData(entity_params, 1);
    });
    return {
      fetchData,
      templates,
      isLoading,
    };
  },
};
</script>
